module.exports = __webpack_public_path__ + "img/tilt_bottom.2becc45e.svg";